import { render, staticRenderFns } from "./allTrash.vue?vue&type=template&id=48f7b5bc"
import script from "./allTrash.vue?vue&type=script&lang=js"
export * from "./allTrash.vue?vue&type=script&lang=js"
import style0 from "./allTrash.vue?vue&type=style&index=0&id=48f7b5bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports